import { useEffect, useState } from "react";
import { getFeatureFlags } from "../services/api";

// Shared read of the global halal feature flag (GET /v1/config/features).
// Kept at module scope so every page sees the same value and a single
// in-flight request, instead of each one fetching the flag on its own.
let cachedValue = false;
let inFlight = null;
const listeners = new Set();

const notify = (value) => {
  cachedValue = value === true;
  listeners.forEach((listener) => listener(cachedValue));
};

const fetchFlag = () => {
  if (inFlight) return inFlight;
  inFlight = getFeatureFlags()
    .then((data) => {
      // Default OFF: only enabled when the server explicitly returns true.
      const enabled = data?.halalEnabled === true;
      notify(enabled);
      return enabled;
    })
    .catch(() => {
      // Fail closed so halal stays hidden if the flag can't be fetched.
      notify(false);
      return false;
    })
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
};

export default function useHalalFeature() {
  const [halalEnabled, setHalalEnabled] = useState(cachedValue);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    const listener = (value) => {
      if (mounted) setHalalEnabled(value);
    };
    listeners.add(listener);

    fetchFlag().finally(() => {
      if (mounted) setLoading(false);
    });

    return () => {
      mounted = false;
      listeners.delete(listener);
    };
  }, []);

  return { halalEnabled, loading, refresh: fetchFlag };
}
